import common from '@/components/common/'
import request from '@/config/request.js'
import moment from 'moment'

const ApiClue = request.Clue

const PLATFORM_OPTIONS = [
  { value: 0, label: '不区分平台' },
  { value: 1, label: '点评' },
  { value: 2, label: '美团' }
]

const LAST_LEADS_SOURCE_OPTIONS = [
  { value: 21, label: '门店电话' },
  { value: 22, label: '在线咨询' },
  { value: 23, label: '预约' },
  { value: 24, label: '交易' },
  { value: 25, label: '营销推广' },
  { value: 26, label: '虚拟号电话' },
  { value: 27, label: '线下录入' },
  { value: 28, label: '直播' },
  { value: 29, label: '营销活动' },
  { value: 40, label: '其他' }
]

const INTENTION_OPTIONS = [
  { value: 1, label: '服务购买成功', group: '有效客资' },
  { value: 2, label: '到店', group: '有效客资' },
  { value: 3, label: '聊到相关服务', group: '有效客资' },
  { value: 22, label: '留线索', group: '有效客资' },
  { value: 23, label: '回访-电话接通', group: '有效客资' },
  { value: 24, label: '回访-信息确认', group: '有效客资' },
  { value: 25, label: '回访-发现意向', group: '有效客资' },
  { value: 26, label: '回访-高潜成交', group: '有效客资' },
  { value: 27, label: '回访-成单客户', group: '有效客资' },
  { value: 29, label: '微信加粉成功', group: '有效客资' },
  { value: 4, label: '无效对话', group: '无效客资' },
  { value: 5, label: '恶意/骚扰', group: '无效客资' },
  { value: 13, label: '空错号', group: '无效客资' },
  { value: 14, label: '回访-电话3次未接通', group: '无效客资' },
  { value: 15, label: '非本人', group: '无效客资' },
  { value: 16, label: '无意向', group: '无效客资' },
  { value: 32, label: '其他', group: '无效客资' }
]

const INTENTION_TAG_TYPE_MAP = {
  valid: 'success',
  invalid: 'danger',
  default: ''
}

function getPlatformLabel (v) {
  const value = v === '' || v === null || v === undefined ? '' : Number(v)
  if (value === '' || Number.isNaN(value)) return '—'
  const hit = PLATFORM_OPTIONS.find(i => i.value === value)
  return hit ? hit.label : '—'
}

function getLastLeadsSourceLabel (v) {
  const value = v === '' || v === null || v === undefined ? '' : Number(v)
  if (value === '' || Number.isNaN(value)) return '—'
  const hit = LAST_LEADS_SOURCE_OPTIONS.find(i => i.value === value)
  return hit ? hit.label : '—'
}

function getIntentionInfo (v) {
  const value = v === '' || v === null || v === undefined ? '' : Number(v)
  if (value === '' || Number.isNaN(value)) {
    return { label: '—', group: '', tagType: '' }
  }
  const hit = INTENTION_OPTIONS.find(i => i.value === value)
  if (!hit) return { label: '—', group: '', tagType: '' }
  const group = hit.group || ''
  let tagType = INTENTION_TAG_TYPE_MAP.default
  if (group === '有效客资') {
    tagType = INTENTION_TAG_TYPE_MAP.valid
  } else if (group === '无效客资') {
    tagType = INTENTION_TAG_TYPE_MAP.invalid
  }
  return {
    label: hit.label,
    group: group,
    tagType: tagType
  }
}

export default {
  name: 'clue-meituan',
  components: {
    ...common
  },
  data () {
    return {
      loading: false,
      loadingCount: 0,
      pageMode: 'list',
      searchForm: {
        followStatus: '',
        customerName: '',
        platform: '',
        lastLeadsFirstSource: '',
        intention: '',
        dateRange: [
          moment().subtract(7, 'day').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ]
      },
      platformOptions: [{ label: '全部留资平台', value: '' }, ...PLATFORM_OPTIONS.map(i => ({ label: i.label, value: i.value }))],
      lastLeadsSourceOptions: [{ label: '全部留资来源', value: '' }, ...LAST_LEADS_SOURCE_OPTIONS.map(i => ({ label: i.label, value: i.value }))],
      intentionOptions: [{ label: '全部意向度', value: '' }, ...INTENTION_OPTIONS.map(i => ({ label: i.label, value: i.value, group: i.group }))],
      followStatusOptions: [{ label: '全部状态', value: '' }],
      statisticsData: {
        pendingCount: 0,
        pendingDelta: 0,
        contactedCount: 0,
        contactedDelta: 0,
        convertedRegularPriceCount: 0,
        convertedRegularPriceDelta: 0,
        conversionRate: 0,
        conversionRateDelta: 0
      },
      phoneVisibleMap: {},
      tableList: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      returnDialogVisible: false,
      returnTargetRow: null,
      returnForm: {
        returnReason: ''
      },
      returnRules: {
        returnReason: [
          { required: true, message: '请输入退回备注', trigger: 'blur' }
        ]
      },
      currentRow: null,
      followHistory: [],
      followForm: {
        followStatus: '',
        nextFollowTime: '',
        content: '',
        remark: ''
      },
      followRules: {
        followStatus: [
          { required: true, message: '请选择新状态', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入跟进内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    followStatusOptionsNoAll: function () {
      return this.followStatusOptions.filter(i => i.value)
    },
    followStatusOptionsNoReturned: function () {
      return this.followStatusOptionsNoAll.filter(i => String(i.value || '').trim() !== 'RETURNED')
    },
    tableHeight: function () {
      return window.innerHeight - 380
    },
    filteredList: function () {
      return Array.isArray(this.tableList) ? this.tableList : []
    },
    pagedList: function () {
      return Array.isArray(this.tableList) ? this.tableList : []
    },
    kpiCards: function () {
      const data = this.statisticsData || {}
      const rate = Number(data.conversionRate || 0).toFixed(2) + '%'
      return [
        {
          key: 'wait',
          title: '待跟进',
          value: data.pendingCount || 0,
          deltaType: Number(data.pendingDelta || 0) < 0 ? 'down' : 'up',
          deltaText: data.pendingDelta || 0
        },
        {
          key: 'contacted',
          title: '已联系',
          value: data.contactedCount || 0,
          deltaType: Number(data.contactedDelta || 0) < 0 ? 'down' : 'up',
          deltaText: data.contactedDelta || 0
        },
        {
          key: 'converted',
          title: '转正价',
          value: data.convertedRegularPriceCount || 0,
          deltaType: Number(data.convertedRegularPriceDelta || 0) < 0
            ? 'down'
            : 'up',
          deltaText: data.convertedRegularPriceDelta || 0
        },
        {
          key: 'rate',
          title: '转化率',
          value: rate,
          deltaType: Number(data.conversionRateDelta || 0) < 0 ? 'down' : 'up',
          deltaText: data.conversionRateDelta || 0
        }
      ]
    }
  },
  mounted () {
    this.initStatusOptions()
    this.loadStatistics()
    this.loadList()
  },
  methods: {
    beginLoading () {
      this.loadingCount += 1
      this.loading = this.loadingCount > 0
    },
    endLoading () {
      this.loadingCount = this.loadingCount > 0 ? this.loadingCount - 1 : 0
      this.loading = this.loadingCount > 0
    },
    initStatusOptions () {
      this.beginLoading()
      ApiClue.meituanGoodlifeClueStatusOptions.call(
        this,
        {},
        (res) => {
          const arr = Array.isArray(res)
            ? res
            : (res && Array.isArray(res.data) ? res.data : [])
          const list = arr
            .filter(i => i && i.label && i.value)
            .map(i => ({ label: i.label, value: i.value }))
          this.followStatusOptions = [
            { label: '全部状态', value: '' },
            ...list
          ]
          this.endLoading()
        },
        () => {
          this.endLoading()
        }
      )
    },
    loadStatistics () {
      const data = this.buildListParams()
      this.beginLoading()
      ApiClue.meituanGoodlifeClueStatistics.call(
        this,
        data,
        (res) => {
          const data = res || {}
          this.statisticsData = {
            pendingCount: Number(data.pendingCount || 0),
            pendingDelta: Number(data.pendingDelta || 0),
            contactedCount: Number(data.contactedCount || 0),
            contactedDelta: Number(data.contactedDelta || 0),
            convertedRegularPriceCount: Number(data.convertedRegularPriceCount || 0),
            convertedRegularPriceDelta: Number(data.convertedRegularPriceDelta || 0),
            conversionRate: Number(data.conversionRate || 0),
            conversionRateDelta: Number(data.conversionRateDelta || 0)
          }
          this.endLoading()
        },
        () => {
          this.endLoading()
        }
      )
    },
    buildListParams () {
      const dr = Array.isArray(this.searchForm.dateRange)
        ? this.searchForm.dateRange
        : []
      const data = {
        offset: (this.pagination.page - 1) * this.pagination.limit,
        limit: this.pagination.limit,
        sort: 'createdTime',
        order: 'desc'
      }
      const filters = []
      const customerName = String(this.searchForm.customerName || '').trim()
      const followStatus = String(this.searchForm.followStatus || '').trim()
      const startDate = dr[0] ? String(dr[0]).trim() : ''
      const endDateRaw = dr[1] ? String(dr[1]).trim() : ''
      const endDate = endDateRaw && endDateRaw.length <= 10
        ? (endDateRaw + ' 23:59:59')
        : endDateRaw
      if (customerName) {
        filters.push({
          field: 'name',
          operator: 'like',
          value: customerName
        })
      }
      if (followStatus) {
        filters.push({
          field: 'meituanClue.status',
          operator: 'eq',
          value: followStatus
        })
      }
      const platformRaw = this.searchForm.platform === 0 ? 0 : this.searchForm.platform
      const platformValue = platformRaw === '' || platformRaw === null || platformRaw === undefined ? '' : Number(platformRaw)
      if (platformValue !== '' && !Number.isNaN(platformValue)) {
        filters.push({
          field: 'platform',
          operator: 'eq',
          value: platformValue
        })
      }
      const sourceRaw = this.searchForm.lastLeadsFirstSource
      const sourceValue = sourceRaw === '' || sourceRaw === null || sourceRaw === undefined ? '' : Number(sourceRaw)
      if (sourceValue !== '' && !Number.isNaN(sourceValue)) {
        filters.push({
          field: 'lastLeadsFirstSource',
          operator: 'eq',
          value: sourceValue
        })
      }
      const intentionRaw = this.searchForm.intention
      const intentionValue = intentionRaw === '' || intentionRaw === null || intentionRaw === undefined ? '' : Number(intentionRaw)
      if (intentionValue !== '' && !Number.isNaN(intentionValue)) {
        filters.push({
          field: 'intention',
          operator: 'eq',
          value: intentionValue
        })
      }
      if (startDate) {
        filters.push({
          field: 'createdTime',
          operator: 'ge',
          value: startDate
        })
      }
      if (endDate) {
        filters.push({
          field: 'createdTime',
          operator: 'le',
          value: endDate
        })
      }
      if (filters.length) data.filters = filters
      return data
    },
    getPlatformLabel: getPlatformLabel,
    getLastLeadsSourceLabel: getLastLeadsSourceLabel,
    getIntentionLabel (v) {
      return getIntentionInfo(v).label
    },
    getIntentionTagType (v) {
      return getIntentionInfo(v).tagType
    },
    formatTime (value, format) {
      const fmt = format || 'YYYY-MM-DD HH:mm'
      if (value === '' || value === null || value === undefined) return '—'
      const raw = String(value).trim()
      if (!raw) return '—'
      if (moment(raw, moment.ISO_8601, true).isValid()) {
        return moment(raw).format(fmt)
      }
      if (/^\d+$/.test(raw)) {
        const num = Number(raw)
        if (!isNaN(num)) {
          const ts = raw.length === 10 ? num * 1000 : num
          return moment(ts).isValid() ? moment(ts).format(fmt) : '—'
        }
      }
      return '—'
    },
    getMobileVisibleKey (row) {
      const item = row || {}
      return String(item.id || item.clueId || item.telephone || '')
    },
    isMobileVisible (row) {
      const key = this.getMobileVisibleKey(row)
      return key ? !!this.phoneVisibleMap[key] : false
    },
    maskMobile (mobile) {
      const value = String(mobile == null ? '' : mobile).trim()
      if (!value || value === '—') return '—'
      if (value.length <= 7) return value
      return value.slice(0, 3) + '****' + value.slice(-4)
    },
    getDisplayMobile (row) {
      const item = row || {}
      const mobile = String(item.phone == null ? '' : item.phone).trim()
      if (!mobile) return '—'
      return this.isMobileVisible(item) ? mobile : this.maskMobile(mobile)
    },
    toggleMobileVisible (row) {
      const key = this.getMobileVisibleKey(row)
      if (!key) return
      this.$set(this.phoneVisibleMap, key, !this.phoneVisibleMap[key])
    },
    mapTableItem (item) {
      const row = item || {}
      const meituanGoodlifeClue = row.meituanGoodlifeClue || {}
      return {
        ...row,
        customerName: row.name || '未命名',
        mobile: row.telephone || '—',
        intentionCourse: row.productName || '—',
        source: '美团获客',
        assignTime: this.formatTime(meituanGoodlifeClue.assignedTime),
        followStatus: meituanGoodlifeClue.status || '',
        lastFollowTime: this.formatTime(meituanGoodlifeClue.latestFollowTime),
        sourceDate: this.formatTime(row.createTimeDetail, 'YYYY-MM-DD')
      }
    },
    loadList () {
      const data = this.buildListParams()
      this.beginLoading()
      ApiClue.meituanGoodlifeCluePage.call(
        this,
        data,
        (res) => {
          const list = res && Array.isArray(res.content) ? res.content : []
          this.tableList = list.map(item => this.mapTableItem(item))
          this.pagination.total = parseInt(res && res.totalElements, 10) || 0
          this.endLoading()
        },
        () => {
          this.tableList = []
          this.pagination.total = 0
          this.endLoading()
        }
      )
    },
    getStatusValueByLabel (label) {
      const s = String(label == null ? '' : label).trim()
      const list = Array.isArray(this.followStatusOptionsNoAll)
        ? this.followStatusOptionsNoAll
        : []
      const hit = list.find(i => String(i.label || '').trim() === s)
      return hit && hit.value ? hit.value : ''
    },
    getMeituanGoodlifeClueDetailId (row) {
      const item = row || {}
      return item.id || ''
    },
    getMeituanGoodlifeClueId (row) {
      const item = row || {}
      return item.id || ''
    },
    formatSubmitDateTime (value) {
      const s = String(value == null ? '' : value).trim()
      if (!s) return ''
      const m = moment(s, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true)
      return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : ''
    },
    mapFollowHistoryItem (item) {
      const row = item || {}
      const nextFollowTime = row.nextFollowTime
        ? this.formatTime(row.nextFollowTime)
        : ''
      return {
        id: row.id || (row.createdTime + '-' + row.updatedTime),
        time: this.formatTime(row.createdTime, 'YYYY-MM-DD HH:mm:ss'),
        actor: row.followTeacherId ? '【跟进记录】' : '',
        message: row.followContent || '—',
        returnReason: row.returnReason || '',
        zoneName: row.zoneName || '',
        fromStatus: row.oldStatus || '',
        toStatus: row.newStatus || '',
        nextFollowTime: nextFollowTime
      }
    },
    loadFollowHistory (row) {
      const meituanClueId = this.getMeituanGoodlifeClueId(row)
      if (!meituanClueId) {
        this.followHistory = []
        return
      }
      this.beginLoading()
      ApiClue.meituanGoodlifeClueListFollowRecords.call(
        this,
        { meituanClueId: meituanClueId },
        (res) => {
          const list = Array.isArray(res)
            ? res
            : (res && Array.isArray(res.data) ? res.data : [])
          this.followHistory = list.map(item => this.mapFollowHistoryItem(item))
          this.endLoading()
        },
        () => {
          this.followHistory = []
          this.endLoading()
        }
      )
    },
    loadDetail (row) {
      const meituanClueId = this.getMeituanGoodlifeClueDetailId(row)
      if (!meituanClueId) return
      this.beginLoading()
      ApiClue.meituanGoodlifeClueDetail.call(
        this,
        { meituanClueId: meituanClueId },
        (res) => {
          this.currentRow = this.mapTableItem(res || {})
          this.endLoading()
        },
        () => {
          this.endLoading()
        }
      )
    },
    statusLabel (v) {
      const value = String(v == null ? '' : v).trim()
      if (!value) return '—'
      const list = Array.isArray(this.followStatusOptionsNoAll)
        ? this.followStatusOptionsNoAll
        : []
      const hit = list.find(i => String(i.value || '').trim() === value)
      if (hit && hit.label) return hit.label
      const fallback = {
        WAIT: '待跟进',
        CONTACTED: '已联系',
        RESERVED: '预约体验',
        NOT_CONTACTED: '未联系上',
        CONVERTED: '转正价',
        UNCONTACTED: '待跟进',
        UNREACHED: '未联系上',
        BOOKED_EXPERIENCE: '已预约',
        WRITTEN_OFF: '已核销',
        EXPERIENCED: '已体验',
        CONVERTED_REGULAR_PRICE: '转正价',
        REFUNDED: '退款',
        RETURNED: '退回'
      }
      return fallback[value] || '—'
    },
    statusTagType (v) {
      const value = String(v == null ? '' : v).trim()
      const map = {
        WAIT: 'warning',
        CONTACTED: 'info',
        RESERVED: 'success',
        NOT_CONTACTED: 'danger',
        CONVERTED: 'success',
        UNCONTACTED: 'warning',
        UNREACHED: 'danger',
        BOOKED_EXPERIENCE: 'success',
        WRITTEN_OFF: 'info',
        EXPERIENCED: 'success',
        CONVERTED_REGULAR_PRICE: 'success',
        REFUNDED: 'danger',
        RETURNED: 'info'
      }
      return map[value] || ''
    },
    canReturn (row) {
      const item = row || {}
      return String(item.followStatus || '').trim() !== 'CONVERTED_REGULAR_PRICE'
    },
    onSearch () {
      this.pagination.page = 1
      this.loadList()
      this.loadStatistics()
    },
    onReset () {
      this.searchForm.followStatus = ''
      this.searchForm.customerName = ''
      this.searchForm.platform = ''
      this.searchForm.lastLeadsFirstSource = ''
      this.searchForm.intention = ''
      this.searchForm.dateRange = [
        moment().subtract(7, 'day').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ]
      this.onSearch()
    },
    onPagination (p) {
      this.pagination.page = p.page
      this.pagination.limit = p.limit
      this.loadList()
    },
    onDetail (row) {
      this.currentRow = row || null
      this.pageMode = 'detail'
      this.loadDetail(row)
      this.loadFollowHistory(row)
      this.resetFollowForm()
    },
    onBackToList () {
      this.pageMode = 'list'
      this.currentRow = null
    },
    onFollow (row) {
      this.onDetail(row)
      this.$nextTick(() => {
        const ref = this.$refs.followFormRef
        if (ref && ref.clearValidate) ref.clearValidate()
      })
    },
    resetFollowForm () {
      this.followForm.followStatus = ''
      this.followForm.nextFollowTime = ''
      this.followForm.content = ''
      this.followForm.remark = ''
      this.$nextTick(() => {
        const ref = this.$refs.followFormRef
        if (ref && ref.clearValidate) ref.clearValidate()
      })
    },
    onCancelFollow () {
      this.resetFollowForm()
      this.onBackToList()
    },
    resetReturnForm () {
      this.returnForm.returnReason = ''
      this.returnTargetRow = null
      this.$nextTick(() => {
        const ref = this.$refs.returnFormRef
        if (ref && ref.clearValidate) ref.clearValidate()
      })
    },
    submitFollowRecord (data, row, successMessage) {
      this.beginLoading()
      ApiClue.meituanGoodlifeClueCreateFollowRecord.call(
        this,
        data,
        () => {
          const targetRow = row || this.currentRow
          const currentClueId = this.currentRow
            ? this.getMeituanGoodlifeClueId(this.currentRow)
            : ''
          if (targetRow) {
            targetRow.followStatus = data.newStatus
            targetRow.lastFollowTime = moment().format('YYYY-MM-DD HH:mm')
            if (targetRow.meituanGoodlifeClue) {
              targetRow.meituanGoodlifeClue.status = data.newStatus
              targetRow.meituanGoodlifeClue.latestFollowTime = moment().valueOf()
            }
          }
          this.$message({
            message: successMessage || '保存成功',
            type: 'success'
          })
          this.endLoading()
          if (currentClueId && currentClueId === data.meituanClueId) {
            this.loadFollowHistory(this.currentRow)
            this.resetFollowForm()
          }
          this.loadStatistics()
        },
        () => {
          this.endLoading()
        }
      )
    },
    onSaveFollow () {
      const ref = this.$refs.followFormRef
      if (!ref || !ref.validate) return
      ref.validate((valid) => {
        if (!valid) return
        const meituanClueId = this.getMeituanGoodlifeClueId(this.currentRow)
        if (!meituanClueId) return
        const data = {
          meituanClueId: meituanClueId,
          newStatus: this.followForm.followStatus,
          nextFollowTime: this.formatSubmitDateTime(this.followForm.nextFollowTime),
          followContent: String(this.followForm.content || '').trim(),
          remark: String(this.followForm.remark || '').trim()
        }
        this.submitFollowRecord(data, this.currentRow, '保存成功')
      })
    },
    onReturn (row) {
      if (!this.canReturn(row)) return
      this.returnTargetRow = row || null
      this.returnDialogVisible = true
      this.$nextTick(() => {
        const ref = this.$refs.returnFormRef
        if (ref && ref.clearValidate) ref.clearValidate()
      })
    },
    onCancelReturn () {
      this.returnDialogVisible = false
      this.resetReturnForm()
    },
    onConfirmReturn () {
      const ref = this.$refs.returnFormRef
      if (!ref || !ref.validate) return
      ref.validate((valid) => {
        if (!valid) return
        const targetRow = this.returnTargetRow || {}
        const meituanClueId = this.getMeituanGoodlifeClueId(targetRow)
        if (!meituanClueId) return
        const returnReason = String(this.returnForm.returnReason || '').trim()
        const data = {
          meituanClueId: meituanClueId,
          newStatus: 'RETURNED',
          returnReason: returnReason
        }
        this.returnDialogVisible = false
        this.submitFollowRecord(data, targetRow, '退回成功')
        this.resetReturnForm()
      })
    }
  }
}
